import baseService, { Service } from './baseService';
import { getModelTypeIdAndEntityId } from '../config';

export const loginService = (credentials) => {
    return Service.post('/customer-auth/login', credentials, { params: getModelTypeIdAndEntityId() });
};

export const forgotPasswordService = (payload) => {
    return Service.post('/customer-auth/forgot-password', payload, { params: getModelTypeIdAndEntityId() });
};

export const validateSetPasswordTokenService = (token) => {
    return Service.post('/customer-auth/validate-set-password-token', { token });
};

export const resetPasswordService = (payload) => {
    return Service.post('/customer-auth/reset-password', payload);
};

export const updatePasswordService = (data) => {
    return baseService.put('/customer-auth/update-password', data);
};

export const checkPassword = (data) => {
    return baseService.post('/customer-auth/check-password', { data });
};

export const loginImageService = () => {
    return Service.get('/auth/login-image');
};
